'use strict';

let lodash = require('lodash');

import Query from './Query';

export default class QueryBuilder {

    constructor() {
        this.reset();
    }

    reset() {
        this._connection  = '';
        this._filters     = null;
        this._first       = null;
        this._after       = null;
        this._fields      = null;
        this._orderBy     = [];
        this._variables   = {};
        this._otherParams = {};
    }

    variables(variables) {
        this._variables = variables;
        return this;
    }

    args(args) {
        for( let key in args ) {
            if( ! args.hasOwnProperty(key) ) {
                continue;
            }

            let value = args[key];

            switch(key) {
                case 'filters': 
                    this.filters(value);
                    break;

                case 'orderBy': 
                    this.orderBy(value);
                    break;

                case 'fields': 
                    this.fields(value);
                    break;

                case 'first': 
                    this.first(value);
                    break;
                
                case 'after': 
                    this.after(value);
                    break;

                default: 
                    this._otherParams[key] = value;
            }
        }

        return this;
    }

    connection(connection, args = undefined) {
        if( args !== undefined ) {
            this.args(args);
        }

        this._connection = connection;
        return this;
    }

    fields(fields) {
        this._fields = fields;
        return this;
    }

    first(first) {
        this._first = first;
        return this;
    }

    after(after) {
        this._after = after;
    }

    filters(filters) {
        this._filters = filters;
        return this;
    }

    orderBy(orderBy) {

        if( lodash.isString(orderBy) ) {
            this._orderBy.push({ 'sort' : orderBy, 'direction' : 'ASC' });
        } 
        else if( lodash.isArray(orderBy) ) {
            let self = this;
            orderBy.forEach( value => self.orderBy(value));
        }
        else if( lodash.isObject(orderBy) ) {

            for( let sort in orderBy ) {
                if( ! orderBy.hasOwnProperty(sort) ) {
                    continue;
                }

                this._orderBy.push({ 'sort' : sort, 'direction' : orderBy[sort].toUpperCase() });
            }
        }

        return this;
    }

    quote(value)
    {
        if( lodash.isString(value) ) {
            if( value.length > 1 && value[0] == '!' ) {
                value = value.substr(1);
            } else {
                value = '"' + value + '"';
            }
        }

        return value;
    }

    buildFilters(rawFilters) {
        
        if( rawFilters === null ) return null;

        let filters = [];
        let isArray = lodash.isArray(rawFilters);

        for(let name in rawFilters ) {
            if( ! rawFilters.hasOwnProperty(name) ) {
                continue;
            }

            let value = rawFilters[name];            
            if( lodash.isString(value) ) {
                value = this.quote(value)
            } else if( lodash.isObject(value) ) {
                value = this.buildFilters(value);
            }

            if( isArray ) {
                filters.push(value); 
            } else {
                filters.push(name + ':' + value);
            }
        }

        if( isArray ) {
            return '[' + filters.join(',') + ']';
        } else {
            return '{' + filters.join(',') + '}';
        }
    }

    query() {

        let query = this._connection;
        let args = [];

        if( this._filters ) {
            args.push('filters : ' + this.buildFilters(this._filters));
        }

        if( this._orderBy.length > 0 ) {
            args.push('orderBy : ' + this.buildFilters(this._orderBy));
        }

        if( this._after ) {
            args.push('after : "' + this._after + '"');
        }

        if( this._first ) {
            args.push('first : ' + this._first);
        }

        let otherParams = this.buildFilters(this._otherParams);
        otherParams = otherParams.replace(/^.(.*).$/, '$1');
        if( otherParams.length > 0 ) {
            args.push(otherParams);
        }

        if( args.length > 0  ) {
            query += '(' + args.join(', ') + ')';
        }

        query += `{` + this._fields + `}`;

        return new Query(query, this._variables);

    }

    edgesQuery() {
        let query = this._connection;
        let args = [];

        if( this._filters ) {
            args.push('filters : ' + this.buildFilters(this._filters));
        }

        if( this._orderBy.length > 0 ) {
            args.push('orderBy : ' + this.buildFilters(this._orderBy));
        }

        if( this._after ) {
            args.push('after : "' + this._after + '"');
        }

        if( this._first ) {
            args.push('first : ' + this._first);
        }

        let otherParams = this.buildFilters(this._otherParams);
        otherParams = otherParams.replace(/^.(.*).$/, '$1');
        args.push(otherParams);
        
        if( args.length > 0  ) {
            query += '(' + args.join(', ') + ')';
        }

        query += `
            {
                totalCount,
                pageInfo{
                    hasNextPage,
                    hasPreviousPage,
                    startCursor,
                    endCursor
                },
                edges{
                    cursor,
                    node { ` + this._fields + ` }
                }
            }
        `;

        return new Query(query, this._variables);
    }
}



















// WEBPACK FOOTER //
// ./src/graphql/QueryBuilder.js